// This is being used for the expected hours modal in the data reports user assignments page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    const el = event.currentTarget;
    
    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");
    
    // Completely destroy and recreate the turbo frame
    const oldFrame = document.getElementById("expected_hours_modal");
    if (oldFrame) {
      oldFrame.remove();
    }
    
    // Create new turbo frame
    const newFrame = document.createElement("turbo-frame");
    newFrame.id = "expected_hours_modal";
    newFrame.innerHTML = `<div data-expected-hours-modal-target="content" class="space-y-4">Loading...</div>`;
    
    // Find the container and append the new frame
    const container = document.querySelector('.p-6.overflow-y-auto');
    if (container) {
      container.appendChild(newFrame);
    }
    
    // Parse user data from JSON
    const userData = JSON.parse(el.dataset.expectedHoursModalUserData);
    
    // Build params and set src
    const params = new URLSearchParams({
      user_id: el.dataset.expectedHoursModalUserId,
      expected_hours: userData.expected_hours,
      balance_hours: userData.balance_hours,
      billable_hours: JSON.stringify(userData.billable_hours),
      unbillable_hours: JSON.stringify(userData.unbillable_hours),
      month: el.dataset.expectedHoursModalMonth,
      year: el.dataset.expectedHoursModalYear,
      _ts: Date.now()
    });
    
    // Set src to trigger request
    newFrame.setAttribute("src", `/data_reports/expected_hours_modal?${params.toString()}`);
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    // Clear Turbo Frame content and src for next open
    const turboFrame = document.getElementById("expected_hours_modal")
    if (turboFrame) {
      turboFrame.removeAttribute("src")
      turboFrame.innerHTML = `<div data-expected-hours-modal-target="content" class="space-y-4"></div>`
    }
  }
}
